import {
    Box,
    Flex,
    FormControl,
    Text,
    Icon
} from '@chakra-ui/react';
import { IoCloseCircleOutline } from 'react-icons/io5';
import { LuExternalLink } from "react-icons/lu";

const ListPDF = ({ pdfs = [], handleRemovePDF }) => {
    return (
        pdfs.map((pdf) =>
            <FormControl display='flex' key={pdf.id}>
                <Box w="100%" className='service-pdf-list'>
                    <Flex justifyContent='space-between'>
                        <Text width='50%'>{pdf.pdf_name}</Text>
                        <div width='50%'>
                            <Icon
                                as={LuExternalLink}
                                h={6}
                                w={6}
                                me="20px"
                                onClick={() => window.open(pdf.pdf, '_blank')}
                                cursor="pointer"
                                title='Open File'
                                color='#fa8f03'
                            />
                            <Icon
                                as={IoCloseCircleOutline}
                                h={7}
                                w={7}
                                onClick={() => handleRemovePDF(pdf.id)}
                                cursor="pointer"
                                title='Remove File'
                                color='red'
                            />
                        </div>
                    </Flex>
                </Box>
            </FormControl>
        )
    )
}

export default ListPDF